import { render, staticRenderFns } from "./NewEnumModal.vue?vue&type=template&id=2915429d&"
import script from "./NewEnumModal.vue?vue&type=script&lang=js&"
export * from "./NewEnumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports